import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-[60vh] grid place-items-center text-muted-foreground text-xs tracking-[0.2em] uppercase">
        Loading
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
